import { capitalize } from 'lodash'

export const serializePlanMembers = members =>
  members?.map(member => ({
    id: member.key,
    firstName: capitalize(member?.firstname || ''),
    lastName: capitalize(member?.lastname || ''),
    email: member.email,
    phoneNumber: member.phone,
    dateOfBirth: member.dob,
    sex: member.sex,
    age: member.age,
    relation: member.relation,
    status: member.status,
    permissions: member.permissions,
    isAdmin: member.is_admin,
    emergencyContact: {
      phoneNumber: member.emergency_contact?.phone_number,
      contactName: member.emergency_contact?.contact_name
    },
    pharmacy: member.default_pharmacy,
    hmo_member_id: member.hmo_member_id,
    hmo_data: member.hmo_data,
    hmo_status: member.hmo_data?.status,
    hmo_services: member?.hmo_services,
    app_link_invitation_date: member.app_link_invitation_date
  }))

export const serializePlanMemberToPost = details => {
  let data = {
    first_name: details.firstName,
    last_name: details.lastName,
    email: details.email,
    phone_number: details.phoneNumber,
    date_of_birth: details.dateOfBirth,
    sex: details.sex,
    family_relation_type: details.relation
  }
  if (details.relation === 'parent') {
    data['requested_permissions'] =
      details.permissions.requested_permissions.filter(
        perm => perm.status === 'requested'
      )
  }
  return data
}

export const serializeLocationVerification = state => {
  const { locationVerification } = state.auth
  return {
    address_street: locationVerification.address,
    address_city: locationVerification.city,
    address_state: locationVerification.state,
    address_zip: locationVerification.zipcode,
    is_home_address: locationVerification.isHomeAddress
  }
}

export const serializePlanDetails = planDetails =>
  planDetails?.map(planDetail => {
    const pricing = planDetail?.charges?.[0]?.pricing?.[0]
    const metadata = planDetail?.metadata
    return {
      blackListedStates: planDetail?.BlacklistedStates__c,
      id: planDetail?.id,
      plan_name: planDetail?.name,
      expire_date: planDetail?.effectiveEndDate,
      type: metadata?.type,
      price: pricing?.price,
      clinic: metadata?.clinic, //we need to see how the filter of hide_from_non_clinic works and get the path
      terms: metadata?.terms,
      bullets: metadata?.bullets,
      premium: metadata?.premium,
      parent: metadata?.parent,
      currency: pricing?.currency,
      flag_text: metadata?.flag_text,
      image_name: metadata?.image_name,
      price_note: metadata?.price_note ? metadata.price_note : 'From',
      banner_text: metadata?.banner_text,
      copay_plan_id: metadata?.copay_product_rate_plan,
      copay_visit_price: planDetail?.copay_visit_price,
      copay_charge_id: planDetail?.copay_charge_id,
      visit_price: pricing?.visit_price,
      is_membership: metadata?.is_membership,
      payment_every: metadata?.payment_every,
      plan_duration: metadata?.plan_duration,
      charge: planDetail?.charges?.[0],
      hide_from_non_clinic: metadata?.hide_from_non_clinic,
      is_reimbursement: metadata?.is_reimbursement,
      reimbursement_limit_monthly: planDetail?.reimbursement_limit_monthly,
      is_ppf: metadata?.is_ppf,
      is_gifting: metadata?.is_gifting,
      body: metadata?.ppf_body,
      bullet_title: metadata?.ppf_bullet_title,
      external_bullets: metadata?.ppf_external_bullets,
      is_bnpl: metadata?.is_bnpl,
      is_complete_package: metadata?.is_complete_package,
      discounted_price: metadata?.ppf_discounted_price,
      show_terms: metadata?.ppf_show_terms,
      title: metadata?.ppf_title,
      subtitle: metadata?.subtitle,
      plan_image: metadata?.ppf_plan_image,
      ppf_success_message: metadata?.ppf_success_message,
      is_without_payment: metadata?.is_no_payment_plan,
      template_type: metadata?.template_type,
      plan_cb_summary_pdf: metadata?.plan_cb_summary_pdf,
      plan_coverage_level: metadata?.plan_coverage_level,
      is_adult_dental_hmo_plan: metadata?.is_adult_dental_hmo_plan,
      mental_health_rates: {
        referral: metadata?.mh_price_r_price,
        virtual: metadata?.mh_price_vp_price,
        tier1: metadata?.mh_price_t1_price,
        tier2: metadata?.mh_price_t2_price,
        network: metadata?.mh_price_t1_price
      },
      pcp_rates: {
        referral: metadata?.pcp_r_price,
        virtual: metadata?.pcp_vp_price,
        tier1: metadata?.pcp_t1_price,
        tier2: metadata?.pcp_t2_price,
        network: metadata?.pcp_t1_price
      },
      specialist_rates: {
        referral: metadata?.specialist_r_price,
        virtual: metadata?.specialist_vp_price,
        tier1: metadata?.specialist_t1_price,
        tier2: metadata?.specialist_t2_price,
        network: metadata?.specialist_t1_price
      }
    }
  })

export const serializePlanDetailsStripe = mySubscription =>
  mySubscription?.map(subscription => {
    const planDetail = subscription?.plan_details
    return {
      plan_name: subscription?.plan_name,
      expire_date: subscription?.expire_date,
      type: planDetail?.type,
      price: planDetail?.price,
      terms: planDetail?.terms,
      bullets: planDetail?.bullets,
      parent: planDetail?.parent,
      currency: planDetail?.currency,
      image_name: planDetail?.image_name,
      visit_price: planDetail?.visit_price,
      is_membership: planDetail?.is_membership,
      payment_every: planDetail?.payment_every,
      plan_duration: planDetail?.plan_duration,
      is_reimbursement: planDetail?.is_reimbursement,
      reimbursement_limit_monthly: planDetail?.reimbursement_limit_monthly,
      plan_image: planDetail?.ppf_plan_image
    }
  })

export const serializeMySubscriptions = mySubscription => {
  if (mySubscription) {
    let plan_details
    if (mySubscription?.billing_provider === 'stripe') {
      plan_details = serializePlanDetailsStripe([mySubscription])?.[0]
    } else {
      plan_details = serializePlanDetails([mySubscription?.plan_details])?.[0]
    }
    return [
      {
        id: mySubscription?.id,
        plan_name: mySubscription?.plan_name,
        plan_details: plan_details,
        expire_date:
          mySubscription?.billing_provider === 'stripe'
            ? mySubscription?.next_billing_date
            : mySubscription?.expire_date,
        created_at: mySubscription?.created_at,
        current_period_start: mySubscription?.current_period_start,
        billing_provider: mySubscription?.billing_provider,
        visits_remaining: mySubscription?.visits_remaining
      }
    ]
  }
}

export const serializeFutureSubscriptions = futureSubscription => {
  if (futureSubscription.length > 0) {
    return futureSubscription.map(serializeMySubscriptions)
  }
}

export const serializePaymentDetails = details => {
  const pm = details?.payments?.defaultPaymentMethod
  // Credit card payment methods store their billing address on the payment method
  // itself (creditCardAddress1 etc.). ACH has no address on the method — fall
  // back to the account-level billToContact in that case.
  const billingAddress = pm?.creditCardAddress1
    ? {
        address1: pm.creditCardAddress1,
        address2: pm.creditCardAddress2,
        city: pm.creditCardCity,
        state: pm.creditCardState,
        zipCode: pm.creditCardPostalCode
      }
    : {
        address1: details?.addresses?.billToContact?.address1,
        address2: details?.addresses?.billToContact?.address2,
        city: details?.addresses?.billToContact?.city,
        state: details?.addresses?.billToContact?.state,
        zipCode: details?.addresses?.billToContact?.zipCode
      }

  const invoices = details?.invoices?.map(invoice => ({
    id: invoice?.id,
    invoiceNumber: invoice?.invoiceNumber,
    amount: invoice?.amount,
    balance: invoice?.balance,
    status: invoice?.status,
    invoiceDate: invoice?.invoiceDate,
    dueDate: invoice?.dueDate,
    invoiceFile: invoice?.body
  }))

  const paymentHistory = details?.paymentHistory?.payments?.map(payment => ({
    id: payment?.id,
    paymentNumber: payment?.paymentNumber,
    amount: payment?.amount,
    status: payment?.status,
    effectiveDate: payment?.effectiveDate
  }))

  const paymentMethod = {
    id: pm?.id,
    cardNumber: pm?.cardNumber,
    bankAccountNumber: pm?.bankAccountNumber,
    cardType: pm?.creditCardType,
    expirationMonth: pm?.expirationMonth,
    expirationYear: pm?.expirationYear,
    cardHolderName: pm?.cardHolderName,
    type: pm?.type === 'ACH' ? 'bankAccount' : pm?.type,
    isDefault: pm?.isDefault,
    status: pm?.status
  }
  const newerInvoice = invoices.reduce((max, item) =>
    new Date(item.dueDate) > new Date(max.dueDate) ? item : max
  )

  const accountSummary = {
    lastPaymentAmount: details?.accountSummary?.basicInfo?.lastPaymentAmount,
    lastPaymentDate: details?.accountSummary?.basicInfo?.lastPaymentDate,
    totalBalance: details?.balance?.totalPrice || 0,
    overdueBalance: details?.balance?.overduePrice || 0,
    dueBalance: details?.balance?.duePrice || 0,
    invoiceNumber: newerInvoice?.invoiceNumber,
    invoiceDate: newerInvoice?.invoiceDate,
    dueDate: newerInvoice?.dueDate,
    isAutoPay: details?.accountSummary?.basicInfo?.autoPay,
    hasMultipleSubscriptions:
      details?.accountSummary?.subscriptions?.length > 1 || false
  }

  return {
    billingAddress,
    invoices,
    paymentHistory,
    paymentMethod,
    accountSummary,
    subscriptions: details?.subscriptions
  }
}

export const serializeHmoUnautenticatedPaymentDetails = details => {
  return {
    ...details,
    address: {
      address1: details?.address?.street1,
      address2: details?.address?.street2,
      city: details?.address?.city,
      state: details?.address?.state,
      zipCode: details?.address?.zip
    },
    balance: {
      totalBalance: details?.balance?.totalPrice || 0,
      overdueBalance: details?.balance?.overduePrice || 0,
      dueBalance: details?.balance?.duePrice || 0,
      latestInvoiceDate: details?.balance?.latestInvoiceDate
    }
  }
}
